export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      action: '',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-dashboard',
      },
    },
    {
      name: '数据管理', // 唯一的路由名称
      displayName: '数据管理', // 显示在侧边栏上的名称
      businessName: 'questionBank', // 业务名称，用于权限控制
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-tables', // 侧边栏图标类名
      },
      children: [
        {
          name: 'listQuestion',
          displayName: '题库列表', // 子选项显示的名称
          action: 'list_question', // 子选项的权限控制
        },
        {
          name: 'listUser',
          displayName: '用户列表', // 子选项显示的名称
          action: 'list_user', // 子选项的权限控制
        },
        {
          name: 'listInterview',
          displayName: '面试列表', // 子选项显示的名称
          action: 'list_interview', // 子选项的权限控制
        },
      ],
    },
  ],
}
